"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBracketMatch = instanceOfBracketMatch;
exports.BracketMatchFromJSON = BracketMatchFromJSON;
exports.BracketMatchFromJSONTyped = BracketMatchFromJSONTyped;
exports.BracketMatchToJSON = BracketMatchToJSON;
exports.BracketMatchToJSONTyped = BracketMatchToJSONTyped;
var Ace_1 = require("./Ace");
var CompetitionEvent_1 = require("./CompetitionEvent");
var WinCondition_1 = require("./WinCondition");
var CompetitionBracket_1 = require("./CompetitionBracket");
var BracketMatchMeta_1 = require("./BracketMatchMeta");
var MatchProposal_1 = require("./MatchProposal");
var MatchCheckIn_1 = require("./MatchCheckIn");
var MatchEscalation_1 = require("./MatchEscalation");
var MatchGame_1 = require("./MatchGame");
var BracketAssignment_1 = require("./BracketAssignment");
var StoredTask_1 = require("./StoredTask");
var BracketMatchChannel_1 = require("./BracketMatchChannel");
var Poll_1 = require("./Poll");
var MatchState_1 = require("./MatchState");
var MatchGameReport_1 = require("./MatchGameReport");
var BracketMatchUrl_1 = require("./BracketMatchUrl");
var MatchNote_1 = require("./MatchNote");
/**
 * Check if a given object implements the BracketMatch interface.
 */
function instanceOfBracketMatch(value) {
    return true;
}
function BracketMatchFromJSON(json) {
    return BracketMatchFromJSONTyped(json, false);
}
function BracketMatchFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateModified': json['dateModified'] == null ? undefined : (new Date(json['dateModified'])),
        'owner': json['owner'] == null ? undefined : json['owner'],
        'aces': json['aces'] == null ? undefined : (json['aces'].map(Ace_1.AceFromJSON)),
        'acesInheriting': json['acesInheriting'] == null ? undefined : json['acesInheriting'],
        'bracket': json['bracket'] == null ? undefined : (0, CompetitionBracket_1.CompetitionBracketFromJSON)(json['bracket']),
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'state': json['state'] == null ? undefined : (0, MatchState_1.MatchStateFromJSON)(json['state']),
        'winCondition': json['winCondition'] == null ? undefined : (0, WinCondition_1.WinConditionFromJSON)(json['winCondition']),
        'winConditionAmount': json['winConditionAmount'] == null ? undefined : json['winConditionAmount'],
        'assignment1': json['assignment1'] == null ? undefined : (0, BracketAssignment_1.BracketAssignmentFromJSON)(json['assignment1']),
        'assignment2': json['assignment2'] == null ? undefined : (0, BracketAssignment_1.BracketAssignmentFromJSON)(json['assignment2']),
        'round': json['round'] == null ? undefined : json['round'],
        'winner': json['winner'] == null ? undefined : (0, BracketAssignment_1.BracketAssignmentFromJSON)(json['winner']),
        'games': json['games'] == null ? undefined : (json['games'].map(MatchGame_1.MatchGameFromJSON)),
        'event': json['event'] == null ? undefined : (0, CompetitionEvent_1.CompetitionEventFromJSON)(json['event']),
        'description': json['description'] == null ? undefined : json['description'],
        'reports': json['reports'] == null ? undefined : (json['reports'].map(MatchGameReport_1.MatchGameReportFromJSON)),
        'entry1ReportCompleted': json['entry1ReportCompleted'] == null ? undefined : (new Date(json['entry1ReportCompleted'])),
        'entry2ReportCompleted': json['entry2ReportCompleted'] == null ? undefined : (new Date(json['entry2ReportCompleted'])),
        'dateConflicted': json['dateConflicted'] == null ? undefined : (new Date(json['dateConflicted'])),
        'dateResolved': json['dateResolved'] == null ? undefined : (new Date(json['dateResolved'])),
        'dateDisputed': json['dateDisputed'] == null ? undefined : (new Date(json['dateDisputed'])),
        'negotiableUntil': json['negotiableUntil'] == null ? undefined : (new Date(json['negotiableUntil'])),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'customStartDate': json['customStartDate'] == null ? undefined : json['customStartDate'],
        'scheduler': json['scheduler'] == null ? undefined : (0, Poll_1.PollFromJSON)(json['scheduler']),
        'checkInBegins': json['checkInBegins'] == null ? undefined : (new Date(json['checkInBegins'])),
        'checkInBeginsTask': json['checkInBeginsTask'] == null ? undefined : (0, StoredTask_1.StoredTaskFromJSON)(json['checkInBeginsTask']),
        'checkInDeadline': json['checkInDeadline'] == null ? undefined : (new Date(json['checkInDeadline'])),
        'checkInDeadlineTask': json['checkInDeadlineTask'] == null ? undefined : (0, StoredTask_1.StoredTaskFromJSON)(json['checkInDeadlineTask']),
        'forfeit': json['forfeit'] == null ? undefined : json['forfeit'],
        'activeChannel': json['activeChannel'] == null ? undefined : (0, BracketMatchChannel_1.BracketMatchChannelFromJSON)(json['activeChannel']),
        'note': json['note'] == null ? undefined : (0, MatchNote_1.MatchNoteFromJSON)(json['note']),
        'channels': json['channels'] == null ? undefined : (json['channels'].map(BracketMatchChannel_1.BracketMatchChannelFromJSON)),
        'urls': json['urls'] == null ? undefined : (json['urls'].map(BracketMatchUrl_1.BracketMatchUrlFromJSON)),
        'escalation': json['escalation'] == null ? undefined : (0, MatchEscalation_1.MatchEscalationFromJSON)(json['escalation']),
        'escalations': json['escalations'] == null ? undefined : (json['escalations'].map(MatchEscalation_1.MatchEscalationFromJSON)),
        'proposals': json['proposals'] == null ? undefined : (json['proposals'].map(MatchProposal_1.MatchProposalFromJSON)),
        'checkIns': json['checkIns'] == null ? undefined : (json['checkIns'].map(MatchCheckIn_1.MatchCheckInFromJSON)),
        'meta': json['meta'] == null ? undefined : (0, BracketMatchMeta_1.BracketMatchMetaFromJSON)(json['meta']),
        'prerequisiteMatchIdsCsv': json['prerequisiteMatchIdsCsv'] == null ? undefined : json['prerequisiteMatchIdsCsv'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'scoresCsv': json['scoresCsv'] == null ? undefined : json['scoresCsv'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'arranged': json['arranged'] == null ? undefined : json['arranged'],
        'listed': json['listed'] == null ? undefined : json['listed'],
        'negotiableNow': json['negotiableNow'] == null ? undefined : json['negotiableNow'],
        'illegal': json['illegal'] == null ? undefined : json['illegal'],
    };
}
function BracketMatchToJSON(json) {
    return BracketMatchToJSONTyped(json, false);
}
function BracketMatchToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'version': value['version'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateModified': value['dateModified'] == null ? undefined : ((value['dateModified']).toISOString()),
        'owner': value['owner'],
        'aces': value['aces'] == null ? undefined : (value['aces'].map(Ace_1.AceToJSON)),
        'acesInheriting': value['acesInheriting'],
        'bracket': (0, CompetitionBracket_1.CompetitionBracketToJSON)(value['bracket']),
        'externalId': value['externalId'],
        'state': (0, MatchState_1.MatchStateToJSON)(value['state']),
        'winCondition': (0, WinCondition_1.WinConditionToJSON)(value['winCondition']),
        'winConditionAmount': value['winConditionAmount'],
        'assignment1': (0, BracketAssignment_1.BracketAssignmentToJSON)(value['assignment1']),
        'assignment2': (0, BracketAssignment_1.BracketAssignmentToJSON)(value['assignment2']),
        'round': value['round'],
        'winner': (0, BracketAssignment_1.BracketAssignmentToJSON)(value['winner']),
        'games': value['games'] == null ? undefined : (value['games'].map(MatchGame_1.MatchGameToJSON)),
        'event': (0, CompetitionEvent_1.CompetitionEventToJSON)(value['event']),
        'description': value['description'],
        'reports': value['reports'] == null ? undefined : (value['reports'].map(MatchGameReport_1.MatchGameReportToJSON)),
        'entry1ReportCompleted': value['entry1ReportCompleted'] == null ? undefined : ((value['entry1ReportCompleted']).toISOString()),
        'entry2ReportCompleted': value['entry2ReportCompleted'] == null ? undefined : ((value['entry2ReportCompleted']).toISOString()),
        'dateConflicted': value['dateConflicted'] == null ? undefined : ((value['dateConflicted']).toISOString()),
        'dateResolved': value['dateResolved'] == null ? undefined : ((value['dateResolved']).toISOString()),
        'dateDisputed': value['dateDisputed'] == null ? undefined : ((value['dateDisputed']).toISOString()),
        'negotiableUntil': value['negotiableUntil'] == null ? undefined : ((value['negotiableUntil']).toISOString()),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'customStartDate': value['customStartDate'],
        'scheduler': (0, Poll_1.PollToJSON)(value['scheduler']),
        'checkInBegins': value['checkInBegins'] == null ? undefined : ((value['checkInBegins']).toISOString()),
        'checkInBeginsTask': (0, StoredTask_1.StoredTaskToJSON)(value['checkInBeginsTask']),
        'checkInDeadline': value['checkInDeadline'] == null ? undefined : ((value['checkInDeadline']).toISOString()),
        'checkInDeadlineTask': (0, StoredTask_1.StoredTaskToJSON)(value['checkInDeadlineTask']),
        'forfeit': value['forfeit'],
        'activeChannel': (0, BracketMatchChannel_1.BracketMatchChannelToJSON)(value['activeChannel']),
        'note': (0, MatchNote_1.MatchNoteToJSON)(value['note']),
        'channels': value['channels'] == null ? undefined : (value['channels'].map(BracketMatchChannel_1.BracketMatchChannelToJSON)),
        'urls': value['urls'] == null ? undefined : (value['urls'].map(BracketMatchUrl_1.BracketMatchUrlToJSON)),
        'escalation': (0, MatchEscalation_1.MatchEscalationToJSON)(value['escalation']),
        'escalations': value['escalations'] == null ? undefined : (value['escalations'].map(MatchEscalation_1.MatchEscalationToJSON)),
        'proposals': value['proposals'] == null ? undefined : (value['proposals'].map(MatchProposal_1.MatchProposalToJSON)),
        'checkIns': value['checkIns'] == null ? undefined : (value['checkIns'].map(MatchCheckIn_1.MatchCheckInToJSON)),
        'meta': (0, BracketMatchMeta_1.BracketMatchMetaToJSON)(value['meta']),
        'prerequisiteMatchIdsCsv': value['prerequisiteMatchIdsCsv'],
        'identifier': value['identifier'],
        'scoresCsv': value['scoresCsv'],
        'deletable': value['deletable'],
        'arranged': value['arranged'],
        'listed': value['listed'],
        'negotiableNow': value['negotiableNow'],
        'illegal': value['illegal'],
    };
}
